// front/src/lib/env.ts
export function getEnv(key: string): string {
  const runtimeEnv = (window as unknown as Record<string, unknown>).__ENV__ as
    | Record<string, string>
    | undefined;
  return runtimeEnv?.[key] ?? import.meta.env[key] ?? "";
}
